import React from 'react';
import { t } from '../i18n';

const PDFPreviewFallback = ({ filename, documentType, documentNumber }) => {
  return (
    <div className="bg-white p-8 max-w-4xl mx-auto my-8 shadow-lg rounded-lg">
      <div className="text-center mb-8">
        <h1 className="text-2xl font-bold text-gray-800 mb-2">
          {t('Преглед на PDF: {filename}', { filename })}
        </h1>
        <p className="text-gray-600">
          {t('Тип на документ: {documentType} | Број: {documentNumber}', { documentType, documentNumber })}
        </p>
      </div>
      
      <div className="bg-gray-100 border-2 border-dashed border-gray-300 rounded-lg p-12 text-center">
        <svg className="w-16 h-16 text-gray-400 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
        </svg>
        <h3 className="text-lg font-medium text-gray-900 mb-2">{t('PDF не е достапен')}</h3>
        <p className="text-gray-500 mb-4">
          {t('Ова е привремен приказ. Вистинскиот PDF ќе се прикаже тука откако ќе биде генериран и зачуван на серверот.')}
        </p>
        <div className="bg-blue-50 border border-blue-200 rounded-md p-4 mt-6">
          <h4 className="text-sm font-medium text-blue-800 mb-2">{t('Очекувани функции:')}</h4>
          <ul className="text-sm text-blue-700 text-left space-y-1">
            <li>{t('• Целосен приказ на PDF во прелистувачот')}</li>
            <li>{t('• Преземање')}</li>
            <li>{t('• Печатење')}</li>
            <li>{t('• Прилагоден приказ на мобилни уреди')}</li>
            <li>{t('• Пристап преку QR код')}</li>
          </ul>
        </div>
      </div>
      
      <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="bg-green-50 border border-green-200 rounded-md p-4">
          <h4 className="text-sm font-medium text-green-800 mb-2">{t('✅ Структурата на URL работи')}</h4>
          <p className="text-sm text-green-700">
            {t('Структурата на URL за преглед е правилно имплементирана и достапна преку QR кодови.')}
          </p>
        </div>
        <div className="bg-yellow-50 border border-yellow-200 rounded-md p-4">
          <h4 className="text-sm font-medium text-yellow-800 mb-2">{t('⏳ Интеграција за складирање PDF')}</h4>
          <p className="text-sm text-yellow-700">
            {t('Серверските крајни точки за PDF се креирани и подготвени за интеграција.')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default PDFPreviewFallback;